module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "project-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("Scrapflower Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter2"
    }
  }, [_vm._v("Scrapflower Pillows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter3"
    }
  }, [_vm._v("Vintage Teapot Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birdhouse Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fan Flower Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Block Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Block Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cat and Bird Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cat and Bird Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cross Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plaid Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duck Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plum Party Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cosy Stripe Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cosy Stripe Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plum Garden Village Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plum Village Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plum Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happy Snowman Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happy Snowman Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Materials",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Techniques",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', {
    attrs: {
      "href": "#/Suppliers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0